'use strict';

import Flatpickr from 'flatpickr';
import { Japanese } from 'flatpickr/dist/l10n/ja';
import moment from 'moment';

class DatePicker {
  constructor() {
    'ngInject';
    this.restrict = 'A';
    this.require = 'ngModel';
    this.scope = {
      ngModel: '=',
      ngChange: '&',
      maxRange: '=',
      maxDate: '='
    };
    this.replace = false;
  }

  link(scope, element) {
    const fp = new Flatpickr(element[0], {
      onChange: selectedDates => {
        if(selectedDates.length === 0) { return; }
        scope.$apply(() => {
          scope.ngModel = selectedDates[0];
        });
        scope.ngChange(selectedDates[0]);
      },
      maxDate: scope.maxDate,
      locale: Japanese
    });

    if(scope.maxRange) {
      fp.set('minDate', moment().subtract(scope.maxRange, 'days'));
    }

    scope.$watch('ngModel', newValue => {
      if(fp.selectedDates === newValue) { return; }
      fp.setDate(newValue);
    })
  }
}

export default angular.module('leptonApp.datepicker', [])
  .directive('datepicker', [() => new DatePicker()])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/directive/datepicker/datepicker.directive.js